"use client"
import React from "react"
import { SessionProvider } from "next-auth/react"
import { ThemeProviderMaterialUi } from "./ThemeProviderMaterialUi"

interface Props {
    children: React.ReactNode
}

export const Provider = ({ children }: Props) => {
    return (
        <SessionProvider>
            <ThemeProviderMaterialUi>
                {children}
            </ThemeProviderMaterialUi>
        </SessionProvider>
    )
}